import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { repeatWhen, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BpService } from '../../../../../core/services/bp.service';
import { BpSmsCodeForm, BpVerifyBySmsRequest } from '../registration-by-sms.model';
import { LanguageService } from '../../../../../core/services/language.service';
import { ConfirmBySmsService } from '../../../../../shared/components/modals/confirm-by-sms/confirm-by-sms.service';

@UntilDestroy()
@Component({
  selector: 'tax-registration-by-sms-confirm-phone',
  templateUrl: 'registration-by-sms-confirm-phone.component.html',
  styleUrls: ['registration-by-sms-confirm-phone.component.sass'],
  providers: [
    ConfirmBySmsService,
  ],
})

export class RegistrationBySmsConfirmPhoneComponent {
  @Input() userInfo?: BpVerifyBySmsRequest;

  @Output() confirmed: EventEmitter<void> = new EventEmitter();
  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();

  private newCountdown: Subject<void> = new Subject();
  attemptCount$: Observable<number> = this.confirmBySmsService.attemptCount$;
  countdown$: Observable<string> = this.confirmBySmsService.countdown$
    .pipe(repeatWhen(() => this.newCountdown));

  password = '';

  constructor(
    private router: Router,
    private location: Location,
    private bpService: BpService,
    private languageService: LanguageService,
    private confirmBySmsService: ConfirmBySmsService,
  ) {}

  checkUserPhone(): void {
    this.bpService.submitAndGetForm({
      smsCode: this.password,
      resendSmsCodeAction: false,
    })
      .pipe(untilDestroyed(this))
      .subscribe(
        () => {
          this.confirmed.emit();
        },
      );
  }

  sendPasswordToUserPhone(): void {
    this.bpService.sendMessageCurrentBp('resendCodeMessage').pipe(
      switchMap(() => this.bpService.getCurrentBpFormData<BpSmsCodeForm>()),
      untilDestroyed(this),
    )
      .subscribe(
        () => {
          this.newCountdown.next();
        },
      );
  }
}
